<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("clientes.titulo") }}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-operaciones">
      <DxColumnFixing :enabled="true" />
      <DxColumn data-field="NombreCompleto" :caption="$t('clientes.grid.nombre')"></DxColumn>
      <DxColumn data-field="Documento" :caption="$t('clientes.grid.documento')"></DxColumn>
      <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
      <template #masterDetailTemplate="{ data: cliente }">
        <cliente-operaciones-tab-panel :template-data="cliente" />
      </template> 
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { DxDataGrid, DxColumn, DxColumnFixing, DxMasterDetail } from "devextreme-vue/data-grid";
import { getDefaultGridProperties } from "@helpers/grid-helper";
import { useApi } from "@api/integration";
import type CustomStore from "devextreme/data/custom_store";
import { type DXLoadOptions } from "@/.shared/.api";
import ClienteOperacionesTabPanel from "@/components/clientes/ClienteOperacionesTabPanel.vue";

const api = useApi();
const grid = ref<DxDataGrid>();
const gridSource = ref<CustomStore>();

onMounted(async () => {
  setDataSource();
});

const setDataSource = async () => {

  gridSource.value = api.apiStore({
    key: "IdCliente",
    load: async (p) => {
      const q = p as DXLoadOptions;
      return await api.callStandardApi("getClientesForGrid", { showLoading: false }, q)
    }
  });
}

</script>

<style lang="scss" scoped>
</style>